import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "setting-component" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group form-group-near" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group stage-b-item" }
const _hoisted_6 = { class: "form-group form-group-near stage-b-item" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group stage-b-item" }
const _hoisted_9 = { class: "form-group form-group-near stage-b-item" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "action-block" }
const _hoisted_12 = { class: "form-group stage-b-item" }
const _hoisted_13 = { class: "switch" }

import { trans } from "@/utils/trans";
  import CustomCheckbox from "@/components/_partials/widget/CustomCheckbox.vue";
  import { computed, ref, watch } from "vue";
  import apiClient from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { useToast } from "primevue/usetoast";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AutoLive',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const toast = useToast();

  const options = computed<{ value: number; label: string }[]>(() => {
    const result = [] as { value: number; label: string }[];
    for (let i = 1; i <= 300; i++) {
      result.push({
        value: i,
        label: `${i} sec`
      });
    }

    return result;
  });

  const autoLiveData = ref({
    is_open_next_lot_auto: auctionStore.liveSettings?.is_open_next_lot_auto == 1,
    is_change_bidding_status_auto: auctionStore.liveSettings?.is_change_bidding_status_auto == 1,
    is_complete_current_lot_auto: auctionStore.liveSettings?.is_complete_current_lot_auto == 1,
    open_next_lot_auto_mode: auctionStore.liveSettings?.open_next_lot_auto_mode,
    change_bidding_status_mode: auctionStore.liveSettings?.change_bidding_status_mode,
    complete_current_lot_mode: auctionStore.liveSettings?.complete_current_lot_mode
  });

  const isAutomatedLive = computed({
    get() {
      return (
        autoLiveData.value?.is_open_next_lot_auto &&
        autoLiveData.value?.is_change_bidding_status_auto &&
        autoLiveData.value?.is_complete_current_lot_auto
      );
    },
    set(newValue) {
      autoLiveData.value.is_open_next_lot_auto = newValue;
      autoLiveData.value.is_change_bidding_status_auto = newValue;
      autoLiveData.value.is_complete_current_lot_auto = newValue;
    }
  });

  watch(
    () => auctionStore.liveSettings,
    (newValue) => {
      autoLiveData.value.is_open_next_lot_auto = newValue?.is_open_next_lot_auto == 1;
      autoLiveData.value.is_change_bidding_status_auto = newValue?.is_change_bidding_status_auto == 1;
      autoLiveData.value.is_complete_current_lot_auto = newValue?.is_complete_current_lot_auto == 1;
      autoLiveData.value.open_next_lot_auto_mode = newValue?.open_next_lot_auto_mode;
      autoLiveData.value.change_bidding_status_mode = newValue?.change_bidding_status_mode;
      autoLiveData.value.complete_current_lot_mode = newValue?.complete_current_lot_mode;
    },
    { deep: true }
  );

  const save = () => {
    apiClient.put(auctionStore.routes["auctions.update_live_settings"], autoLiveData.value).then((response) => {
      if (response.data.status && response.data.settings) {
        auctionStore.$patch(response.data.settings);
      } else {
        console.log(response, response.data?.message);
      }
      toast.add({
        severity: response.data.status ? "success" : "error",
        summary: trans("live.toast." + (response.data.status ? "success" : "error")),
        detail: response.data.message || trans("live.toast.unknown_error"),
        life: 6000
      });
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomCheckbox, {
        id: "open-next-lot",
        modelValue: autoLiveData.value.is_open_next_lot_auto,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((autoLiveData.value.is_open_next_lot_auto) = $event)),
        label: _unref(trans)('live.tabs.settings_network.auto_live_tab.labels.open_next_lot_checkbox')
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((autoLiveData.value.open_next_lot_auto_mode) = $event)),
        id: "open-next-lot-duration",
        class: "form-select-field"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(option.label), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, autoLiveData.value.open_next_lot_auto_mode]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(CustomCheckbox, {
        id: "change-bidding-status",
        modelValue: autoLiveData.value.is_change_bidding_status_auto,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((autoLiveData.value.is_change_bidding_status_auto) = $event)),
        label: _unref(trans)('live.tabs.settings_network.auto_live_tab.labels.change_bidding_status_checkbox')
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((autoLiveData.value.change_bidding_status_mode) = $event)),
        id: "change-bidding-status-duration",
        class: "form-select-field"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(option.label), 9, _hoisted_7))
        }), 128))
      ], 512), [
        [_vModelSelect, autoLiveData.value.change_bidding_status_mode]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(CustomCheckbox, {
        id: "close_current_lot",
        modelValue: autoLiveData.value.is_complete_current_lot_auto,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((autoLiveData.value.is_complete_current_lot_auto) = $event)),
        label: _unref(trans)('live.tabs.settings_network.auto_live_tab.labels.close_current_lot')
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((autoLiveData.value.complete_current_lot_mode) = $event)),
        id: "close-current-lot-duration",
        class: "form-select-field"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(option.label), 9, _hoisted_10))
        }), 128))
      ], 512), [
        [_vModelSelect, autoLiveData.value.complete_current_lot_mode]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn btn-blue action",
        onClick: save
      }, _toDisplayString(_unref(trans)("live.tabs.settings_network.auto_live_tab.actions.save")), 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isAutomatedLive).value = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, isAutomatedLive.value]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "slider round" }, null, -1))
        ]),
        _createTextVNode(" " + _toDisplayString(_unref(trans)("live.tabs.settings_network.auto_live_tab.actions.full_auto_auction")), 1)
      ])
    ])
  ]))
}
}

})